module.exports = __webpack_public_path__ + "img/threat-analytics-endpoint-tab.a64b9611.png";